<template>
  <section class="padding-bottom-needed profile-page">
    <br>
    <h1 class="title">
      {{ $root.pageTitle }}
    </h1>
    <div class="columns">
      <div class="columns">
        <div class="column is-6 is-paddingless">
          <p style="margin-bottom: 2em;">
            Manage your personal information
          </p>

          <form
            id="profile"
            @submit="saveProfile"
          >
            <h5>Primary information</h5>

            <div class="name">
              <div class="field">
                <div class="control">
                  <label class="label">
                    <span>First Name</span>
                    <span
                      :data-tooltip="'Required field' + '\n' + 'Allowed character count is 50'"
                      class="tooltip has-tooltip-right has-tooltip-arrow"
                    >
                      <img
                        src="../../../public/assets/img/info.svg"
                        alt=""
                      >
                    </span>
                  </label>
                  <input
                    ref="firstName"
                    v-model="tracking_change.firstname"
                    class="input is-mandatory"
                    :class="errors.firstName.visible ? 'has-error' : ''"
                    type="text"
                    placeholder="First name, eg: Jane, John"
                  >
                  <span v-if="errors.firstName.visible">{{ errors.firstName.message }}</span>
                </div>
              </div>

              <div class="field">
                <div class="control">
                  <label class="label">
                    <span>Last Name</span>
                    <span
                      :data-tooltip="'Required field' + '\n' + 'Allowed character count is 50'"
                      class="tooltip has-tooltip-right has-tooltip-arrow"
                    >
                      <img
                        src="../../../public/assets/img/info.svg"
                        alt=""
                      >
                    </span>
                  </label>
                  <input
                    ref="lastName"
                    v-model="tracking_change.lastname"
                    class="input is-mandatory"
                    :class="errors.lastName.visible ? 'has-error' : ''"
                    type="text"
                    placeholder="Last name, eg: Doe"
                  >
                  <span v-if="errors.lastName.visible">{{ errors.lastName.message }}</span>
                </div>
              </div>
            </div>

            <div class="field">
              <div class="control">
                <label class="label">Email address</label>
                <input
                  class="input"
                  type="email"
                  disabled
                  placeholder="Email, eg: test@example.com"
                  :value="tracking_change.email"
                >
              </div>
              <p class="help">
                Cannot be edited because its used to identify yourself on our platform
              </p>
            </div>

            <h5>Address</h5>

            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Address line 1</span>
                  <span
                    :data-tooltip="'Allowed character count is 50'"
                    class="tooltip has-tooltip-right has-tooltip-arrow"
                  >
                    <img
                      src="../../../public/assets/img/info.svg"
                      alt=""
                    >
                  </span>
                </label>
                <input
                  v-model="tracking_change.address1"
                  class="input is-mandatory"
                  :class="errors.address1.visible ? 'has-error' : ''"
                  type="text"
                  placeholder="Address, eg : 123 Example Street"
                >
                <span v-if="errors.address1.visible">{{ errors.address1.message }}</span>
              </div>
            </div>

            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Address line 2 (optional)</span>
                  <span
                    :data-tooltip="'Allowed character count is 50'"
                    class="tooltip has-tooltip-right has-tooltip-arrow"
                  >
                    <img
                      src="../../../public/assets/img/info.svg"
                      alt=""
                    >
                  </span>
                </label>
                <input
                  v-model="tracking_change.address2"
                  class="input is-mandatory"
                  :class="errors.address2.visible ? 'has-error' : ''"
                  type="text"
                  placeholder="Address, eg : 2nd Floor"
                >
                <span v-if="errors.address2.visible">{{ errors.address2.message }}</span>
              </div>
            </div>

            <div class="city">
              <div class="field">
                <div class="control">
                  <label class="label">
                    <span>City</span>
                    <span
                      :data-tooltip="'Allowed character count is 50'"
                      class="tooltip has-tooltip-right has-tooltip-arrow"
                    >
                      <img
                        src="../../../public/assets/img/info.svg"
                        alt=""
                      >
                    </span>
                  </label>
                  <input
                    v-model="tracking_change.city"
                    class="input is-mandatory"
                    :class="errors.city.visible ? 'has-error' : ''"
                    type="text"
                    placeholder="City, eg : San Diego"
                  >
                  <span v-if="errors.city.visible">{{ errors.city.message }}</span>
                </div>
              </div>

              <div class="field">
                <div class="control">
                  <label class="label">
                    <span>Zip code</span>
                    <span
                      :data-tooltip="'Allowed character count is 50'"
                      class="tooltip has-tooltip-right has-tooltip-arrow"
                    >
                      <img
                        src="../../../public/assets/img/info.svg"
                        alt=""
                      >
                    </span>
                  </label>
                  <input
                    v-model="tracking_change.zipcode"
                    class="input is-mandatory"
                    :class="errors.zipCode.visible ? 'has-error' : ''"
                    type="text"
                    placeholder="Zipcode, eg : 12345"
                  >
                  <span v-if="errors.zipCode.visible">{{ errors.zipCode.message }}</span>
                </div>
              </div>
            </div>

            <div class="state">
              <div class="field">
                <div class="control">
                  <label class="label">
                    <span>State</span>
                    <span
                      :data-tooltip="'Allowed character count is 50'"
                      class="tooltip has-tooltip-right has-tooltip-arrow"
                    >
                      <img
                        src="../../../public/assets/img/info.svg"
                        alt=""
                      >
                    </span>
                  </label>
                  <input
                    v-model="tracking_change.state"
                    class="input is-mandatory"
                    :class="errors.state.visible ? 'has-error' : ''"
                    type="text"
                    placeholder="State, eg : CA"
                  >
                  <span v-if="errors.state.visible">{{ errors.state.message }}</span>
                </div>
              </div>

              <div class="field">
                <div class="control">
                  <label class="label">Country</label>
                  <input
                    class="input"
                    type="text"
                    placeholder="Country, eg : United States of America"
                    value="United States of America"
                    disabled
                  >
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="column is-5 is-offset-1">
          <div
            class="notice-block"
            style="display: flex"
          >
            <i
              class="fas fa-question-circle fa-fw fa-2x"
              aria-hidden="true"
              style="margin-right: 1.125rem"
            />
            <div class="content">
              <p class="has-text-weight-bold">
                Personal information
              </p>
              <p>Your personal information may differ from the company information you work for. You will find below the list of all companies you are attached to:</p>

              <ul
                v-for="(location) in $store.state.locationsList"
                :key="location.uuid"
              >
                <li>{{ location.name }}</li>
              </ul>
              <p>You can easily switch between companies using the top navigation menu</p>
            </div>
          </div>
        </div>
        <div
          id="actionbar"
          class="actionbar-bottom has-background-white"
        >
          <div class="container is-fullhd">
            <div class="columns">
              <div class="column is-12">
                <p class="has-text-right">
                  <button
                    id="saveProfile"
                    type="submit"
                    class="button primary"
                    form="profile"
                  >
                    <span class="icon"><i
                      class="fas fa-save"
                      aria-hidden="true"
                    /></span>
                    <span>Save Profile</span>
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal required-fields-modal"
          :class="{'is-active' : show_required_fields_modal}"
        >
          <div
            class="modal-background"
            @click="hideRequiredFieldsModal"
          />
          <div class="modal-content">
            <div class="box">
              <h5>You have not filled in First Name and Last Lame.</h5>
              <h5>Please fill before you leave.</h5>
              <p
                class="control has-text-right"
                style="margin-top: 2rem"
              >
                <button
                  class="button"
                  @click="hideRequiredFieldsModal"
                >
                  Ok
                </button>
                <button
                  class="button primary"
                  @click="handleLeaveClick"
                >
                  Leave
                </button>
              </p>
            </div>
          </div>
          <button
            class="modal-close is-large"
            aria-label="close"
            @click="hideRequiredFieldsModal"
          />
        </div>

        <!-- Modal if user leave without saving -->
        <div
          class="modal"
          :class="{'is-active' : show_modal_leaving}"
        >
          <div
            class="modal-background"
            @click="show_modal_leaving = false"
          />
          <div class="modal-content">
            <div class="box">
              <h6>Save profile modification?</h6>
              <p>There are some unsaved changes. Would you like to save them before leaving the page?</p>
              <p
                class="control has-text-right"
                style="margin-top: 2rem"
              >
                <a
                  href="#"
                  class="button is-white"
                  @click="hideLeavingModal"
                >Discard</a>
                <a
                  href="#"
                  class="button primary is-outlined"
                  @click="saveAndRedirect"
                >Save</a>
              </p>
            </div>
          </div>
          <button
            class="modal-close is-large"
            aria-label="close"
            @click="show_modal_leaving = false"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>

import UserService from '../../services/user.service';

const userService = new UserService();

export default {
  name: 'UserProfile',
  beforeRouteLeave(to, from, next) {
    const isRequiredFieldsEmpty = this.isRequiredFieldsEmpty();
    const hasUnsavedChanges = this.hasUnsavedChange();

    if (to.name !== 'login' && !this.force_leaving && (isRequiredFieldsEmpty || hasUnsavedChanges)) {
      if (isRequiredFieldsEmpty) {
        this.show_required_fields_modal = true;
        this.redirection_to = to;
        next(false);
      } else if (hasUnsavedChanges) {
        this.show_modal_leaving = true;
        this.redirection_to = to;
        next(false);
      }
    } else {
      this.checkForLogout();
      next();
    }
  },
  data() {
    return {
      tracking_change: {},
      show_modal_leaving: false,
      redirection_to: null,
      show_required_fields_modal: false,
      checkForRedirect: false,
      force_leaving: false,
      errors: {
        firstName: {
          visible: false,
          message: ''
        },
        lastName: {
          visible: false,
          message: ''
        },
        address1: {
          visible: false,
          message: ''
        },
        address2: {
          visible: false,
          message: ''
        },
        city: {
          visible: false,
          message: ''
        },
        zipCode: {
          visible: false,
          message: ''
        },
        state: {
          visible: false,
          message: ''
        }
      }
    };
  },
  mounted() {
    if (document.querySelector('#actionbar')) {
      document.querySelector('.padding-bottom-needed').style.paddingBottom = `${document.querySelector('#actionbar').offsetHeight * 2}px`;
    }
    this.$root.showLocationAdd = false;
    this.$root.pageTitle = 'My profile';
    this.tracking_change = { ...JSON.parse(JSON.stringify(this.$store.state.user)) };
  },
  methods: {
    saveProfile(event, redirectionTo) {
      if (event) { event.preventDefault(); }
      const isValid = this.validateProfile();

      if (!isValid) {
        return;
      }

      const data = new FormData();
      const self = this;
      data.append('data', JSON.stringify(this.tracking_change));

      userService.updateProfile(data)
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-success', duration: 5000 } });
            self.$store.commit('updateUser', self.tracking_change);

            if (redirectionTo || self.checkForRedirect) {
              self.force_leaving = true;
              self.$router.push({ name: self.redirection_to.name });
              self.checkForLogout();
            }
          } else {
            self.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        }).finally(() => {
          self.checkForRedirect = false;
        });
    },
    validateProfile() {
      const {
        firstname, lastname, city, zipcode, state, address1, address2
      } = this.tracking_change;

      let message = '';

      const firstNameError = {
        visible: false,
        message: ''
      };
      const lastNameError = {
        visible: false,
        message: ''
      };
      const address1Error = {
        visible: false,
        message: ''
      };
      const address2Error = {
        visible: false,
        message: ''
      };
      const cityError = {
        visible: false,
        message: ''
      };
      const zipCodeError = {
        visible: false,
        message: ''
      };
      const stateError = {
        visible: false,
        message: ''
      };
      if (!firstname) {
        message += 'First name is required <br >';
        firstNameError.visible = true;
        firstNameError.message = 'First name is required';
      } else if (firstname.length > 50) {
        message += 'Allowed character count is 50 for First name<br >';
        firstNameError.visible = true;
        firstNameError.message = 'Allowed character count is 50';
      }

      if (!lastname) {
        message += 'Last name is required <br >';
        lastNameError.visible = true;
        lastNameError.message = 'Last name is required';
      } else if (lastname.length > 50) {
        message += 'Allowed character count is 50 for Last name<br >';
        lastNameError.visible = true;
        lastNameError.message = 'Allowed character count is 50';
      }

      if (address1 && address1.length > 50) {
        message += 'Allowed character count is 50 for Address 1<br >';
        address1Error.visible = true;
        address1Error.message = 'Allowed character count is 50';
      }

      if (address2 && address2.length > 50) {
        message += 'Allowed character count is 50 for Address 2<br >';
        address2Error.visible = true;
        address2Error.message = 'Allowed character count is 50';
      }

      if (city && city.length > 50) {
        message += 'Allowed character count is 50 for City<br >';
        cityError.visible = true;
        cityError.message = 'Allowed character count is 50';
      }

      if (zipcode && zipcode.length > 50) {
        message += 'Allowed character count is 50 for Zip code<br >';
        zipCodeError.visible = true;
        zipCodeError.message = 'Allowed character count is 50';
      }

      if (state && state.length > 50) {
        message += 'Allowed character count is 50 for State<br >';
        stateError.visible = true;
        stateError.message = 'Allowed character count is 50';
      }
      this.errors = {
        firstName: firstNameError,
        lastName: lastNameError,
        address1: address1Error,
        address2: address2Error,
        city: cityError,
        zipCode: zipCodeError,
        state: stateError
      };
      const isValid = !message.length;

      if (!isValid) {
        this.$root.$emit('showToast', { message, options: { cssClass: 'is-danger', duration: 30000 } });
      }
      return isValid;
    },
    saveAndRedirect() {
      this.saveProfile(null, true);
    },
    hideLeavingModal() {
      this.force_leaving = true;
      this.$router.push({ name: this.redirection_to.name });
      this.checkForLogout();
    },
    hasUnsavedChange() {
      const user = { ...this.$store.state.user };
      const trackingChanges = { ...this.tracking_change };
      const props = [...Object.getOwnPropertyNames(user)];

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < props.length; i++) {
        if (user[props[i]] !== trackingChanges[props[i]]) {
          return true;
        }
      }

      return false;
    },
    isRequiredFieldsEmpty() {
      return !this.tracking_change.firstname || !this.tracking_change.lastname;
    },
    checkForLogout() {
      if (this.$store.state.showLogout) {
        this.$store.commit('logout');
      }
    },
    hideRequiredFieldsModal() {
      this.show_required_fields_modal = false;
      const { firstname, lastname } = this.tracking_change;
      this.errors = {
        ...this.errors,
        firstName: {
          visible: !firstname,
          message: !firstname ? 'First name is required' : ''
        },
        lastName: {
          visible: !lastname,
          message: !lastname ? 'Last name is required' : ''
        }
      };
      this.checkForRedirect = true;
    },
    handleLeaveClick() {
      if (this.redirection_to?.name) {
        this.force_leaving = true;
        this.$store.commit('setAccountReady', true);
        this.$router.push({ name: this.redirection_to.name });
      }
    }
  }
};
</script>
<style scoped src='../../../public/assets/css/bulma-extension/bulma-tooltip.min.css'></style>
<style scoped lang="scss">
    .profile-page {
        .city,
        .state,
        .name {
            display: flex;
            justify-content: space-between;

            .field {
                width: 49%;
            }
        }
        .control {
            display: flex;
            flex-direction: column;
        }

        .required-fields-modal {
            .control {
                display: flex;
                justify-content: space-between;
                flex-direction: row;
            }
        }
    }
</style>
